import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    TimePicker,
    Typography
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllOvertime, takeToil } from "../../redux/rtk/features/overtime/overtimeSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const { TextArea } = Input;
const { Title } = Typography;

const AddToil = ({ drawer }) => {
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    const [toilLoggedDate, setToilLoggedDate] = useState({ date: null, time: null });
    const [toilTakenDate, setToilTakenDate] = useState({ date: null, time: null });
    const [rewardType, setRewardType] = useState("Toil");
    const [overtimeLength, setOvertimeLength] = useState("0 Hours 0 Mins");
    const staffList = useSelector((state) => state.users?.list);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadAllStaff({ status: true }));
    }, [dispatch]);

    const calculateOvertimeLength = () => {
        if (toilLoggedDate.date && toilLoggedDate.time && toilTakenDate.date && toilTakenDate.time) {
            const startDateTime = new Date(
                Date.UTC(
                    toilLoggedDate.date.split('-')[0],
                    toilLoggedDate.date.split('-')[1] - 1,
                    toilLoggedDate.date.split('-')[2],
                    ...toilLoggedDate.time.split(':').map(Number)
                )
            );
            const endDateTime = new Date(
                Date.UTC(
                    toilTakenDate.date.split('-')[0],
                    toilTakenDate.date.split('-')[1] - 1,
                    toilTakenDate.date.split('-')[2],
                    ...toilTakenDate.time.split(':').map(Number)
                )
            );
            const diffMs = Math.abs(endDateTime - startDateTime);
            const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
            const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
            setOvertimeLength(`${diffHrs} Hours ${diffMins} Mins`);
        }
    };

    useEffect(() => {
        calculateOvertimeLength();
    }, [toilLoggedDate, toilTakenDate]);

    const handleFormSubmit = (values) => {
        const rewardTypeValue = rewardType === "Toil" ? false : true;
        const formData = {
            ...values,
            toilLoggedDate: toilLoggedDate.date && toilLoggedDate.time
                ? new Date(Date.UTC(
                    toilLoggedDate.date.split('-')[0],
                    toilLoggedDate.date.split('-')[1] - 1,
                    toilLoggedDate.date.split('-')[2],
                    ...toilLoggedDate.time.split(':').map(Number)
                ))
                : null,
            toilTakenDate: toilTakenDate.date && toilTakenDate.time
                ? new Date(Date.UTC(
                    toilTakenDate.date.split('-')[0],
                    toilTakenDate.date.split('-')[1] - 1,
                    toilTakenDate.date.split('-')[2],
                    ...toilTakenDate.time.split(':').map(Number)
                ))
                : null,
            rewardType: rewardTypeValue
        };

        setLoader(true);

        dispatch(takeToil(formData))
            .then(() => {
                setLoader(false);
                form.resetFields();
                dispatch(getAllOvertime());
                setToilLoggedDate({ date: null, time: null });
                setToilTakenDate({ date: null, time: null });
            })
            .catch((error) => {
                setLoader(false);
                toast.error("Error in logging overtime");
            });
    };

    return (
        <Fragment>
            <UserPrivateComponent permission={"create-attendance"}>
                <Row className="mb-4" justify="center">

                    <Col span={24}>

                        {(toilLoggedDate.time === null || toilLoggedDate.date === null ||
                            toilTakenDate.time === null || toilTakenDate.date === null) ? (
                            <p className='text-center text-rose-500 text-sm font-medium mb-4'>
                                * Please fill Date and Time
                            </p>
                        ) : null}
                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            eventKey='overtime-form'
                            name='basic'
                            labelCol={{
                                span: 8,
                            }}
                            wrapperCol={{
                                span: 14,
                            }}
                            onFinish={handleFormSubmit}
                            autoComplete='off'>
                            <div>
                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Employee'
                                    name='userId'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select an employee!",
                                        },
                                    ]}>
                                    <Select placeholder='Select Employee'
                                    showSearch allowClear
                                    filterOption={(input, option) =>
                                        String(option.children).toLowerCase().includes(input.toLowerCase())
                                    }>
                                        {staffList?.map((staff) => (
                                            <Select.Option key={staff.id} value={staff.id}>
                                                {/* {staff.userName} */}
                                                {staff.firstName} {staff.lastName}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Toil Taken'
                                    name='toilTaken'
                                >
                                    <InputNumber placeholder="Add toil Taken" />
                                </Form.Item>

                                {/* <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Toil Logged'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input toil logged time!",
                                        },
                                    ]}>
                                    <div className='flex justify-between'>
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            onChange={(date, dateString) =>
                                                setToilLoggedDate({ ...toilLoggedDate, date: dateString })
                                            }
                                        />
                                        <TimePicker
                                            className='ml-4'
                                            format={"HH:mm:s"}
                                            onChange={(time, timeString) =>
                                                setToilLoggedDate({ ...toilLoggedDate, time: timeString })
                                            }
                                        />
                                    </div>
                                </Form.Item> */}

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Toil Taken'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input Toil Taken time!",
                                        },
                                    ]}>
                                    <div className='flex justify-between'>
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            onChange={(date, dateString) =>
                                                setToilTakenDate({ ...toilTakenDate, date: dateString })
                                            }
                                            showToday={false}
                                        />
                                        <TimePicker
                                            className='ml-4'
                                            format={"HH:mm"}
                                            onChange={(time, timeString) =>
                                                setToilTakenDate({ ...toilTakenDate, time: timeString })
                                            }
                                            showNow={false}
                                        />
                                    </div>
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    wrapperCol={{
                                        offset: 6,
                                        span: 12,
                                    }}>
                                    <Button
                                        type='primary'
                                        size='large'
                                        htmlType='submit'
                                        block
                                        loading={loader}
                                        disabled={
                                            // toilLoggedDate.time === null ||
                                            // toilLoggedDate.date === null ||
                                            toilTakenDate.time === null ||
                                            toilTakenDate.date === null
                                        }
                                    >
                                        Toil
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </UserPrivateComponent>
        </Fragment>
    );
};

export default AddToil;